import React from 'react';
import moment from 'moment';
import {Card, Table, Loader} from 'semantic-ui-react';
import {ordersTypes} from '../../../common/dictionaries/accessories';
import {fullDate} from '../../../common/constants/datesFormat';

const LoaderTable = () => {
  return (
    <Table.Row>
      <Table.Cell colSpan='100%'>
        <Loader active inline='centered' />
      </Table.Cell>
    </Table.Row>
  );
};

const Comments = ({comments}) => {
  if (!comments.length) {
    return (
      <Table.Row textAlign='center'>
        <Table.Cell colSpan={5}>
          No hay observaciones en órdenes anteriores para el chasis seleccionado
        </Table.Cell>
      </Table.Row>
    );
  }

  return comments.map((element, index) => {
    const dateFormatted = element.creationDate ?
      moment(element.creationDate).format(fullDate) :
      '';
    return (
      <Table.Row key={index} textAlign='center'>
        <Table.Cell width={2}>{ordersTypes[element.orderType]}</Table.Cell>
        <Table.Cell width={2}>{element.order}</Table.Cell>
        <Table.Cell>{element.comment}</Table.Cell>
        <Table.Cell width={2}>{dateFormatted}</Table.Cell>
        <Table.Cell width={3}>{element.statusId} - {element.status}</Table.Cell>
      </Table.Row>
    );
  });
};

const TableCommentsByChassis = ({loading, comments}) => {
  return (
    <Card raised fluid>
      <div className='title-bar'>
        <div className='title'>
          <h2>Observaciones de órdenes anteriores:</h2>
        </div>
      </div>

      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Orden</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Observación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {loading ? <LoaderTable /> : <Comments comments={comments} />}
        </Table.Body>
      </Table>
    </Card>
  );
};

export default TableCommentsByChassis;
